module.exports = __webpack_public_path__ + "static/media/everyday_digital.152a8204.png";